const aboutUsData = {
    titleImg: "/static/img/aboutus/banner.jpg",
    titleContent: "中科虹星科技有限公司是一家由中国科学院自动化研究所在人工智能领域孵化的高科技企业。虹星科技基于自主研发的远距离虹膜识别和智能三维人机交互两大核心技术，领先推出国内商业化远距离虹膜识别产品，实现了适用于大规模人群下的具有鲁棒三维活体检测的高精度身份认证。虹星科技以打造通行世界的身份钥匙为己任，致力于远距离虹膜人脸融合识别、智能视觉传感器、生物多属性分析云服务等领域的探索和研发，为公安司法 、反恐维稳、边检、安防、机器人、金融、互联网、零售、教育、房地产等行业提供大规模视觉数据采集、分析和管理的硬件—软件—算法整体解决方案。",
    people: [{
        id: "1",
        userImg: "/static/img/aboutus/tan.jpg",
        name: "谭铁牛",
        position: "行业领军人物、技术发明人",
        desc: "中国科学院院士、英国皇家工程院外籍院士、发展中国家科学院院士和巴西科学院通讯院士。中国科学院自动化研究所智能感知与计算研究中心主任、研究员，博士生导师。中国人工智能学会副理事长、中国图象图形学学会理事长。曾获中国青年五四奖章、中国青年科技奖以及国家自然科学二等奖、国家技术发明二等奖和国家科技进步二等奖各1项。"
    },
    {
        id: "2",
        userImg: "/static/img/aboutus/hou.jpg",
        name: "侯广琦",
        position: "博士、CEO",
        desc: "虹星科技创始人，中国科学院自动化研究所，模式识别国家重点实验室研究员，IEEE会员，SPIE会员，中国光学学会会员，北京图形图像学会会员，同时为IEEE-TIFS、Neurocomputing、Sensors和IJAC等学术期刊的审稿人。主要研究方向为光学成像、计算成像、光场成像、模式识别和计算机视觉，已在国际会议和期刊发表学术论文20余篇，申请发明专利15项，获得软件著作权4项。国家自然科学基金委重大仪器专项、科技部国际交流合作项目、中科院科研装备项目的技术负责人，主持国家自然科学青年基金1项，横向技术开发课题3项，作为科研骨干参与国家自然科学基金委重点项目、北京市科协项目等7项，总经费超过2000万元。"
    },
    {
        id: "3",
        userImg: "/static/img/aboutus/sun.jpg",
        name: "孙哲南",
        position: "研究员、技术顾问",
        desc: "中国科学院自动化研究所副总工程师、研究员，博士生导师、天津中科智能识别产业技术研究院院长，中国生物识别产业技术创新战略联盟秘书长、中国图象图形学会机器视觉专委会副主任、中国人工智能学会模式识别专委会秘书长。主要研究方向是生物特征识别，包括虹膜识别、人脸识别、掌纹识别、联机笔迹识别。在国际期刊和会议发表学术论文180余篇，申请发明专利70多项，获得16项软件著作权，虹膜识别科研成果获得国家技术发明二等奖和国家专利优秀奖，个人获得中科院卢嘉锡青年人才奖。"
    }
    ],
    produce: [
        "虹星科技研发团队源于中科院自动化所模式识别国家重点实验室的远距离虹膜识别科研团队，涵盖光学、电子、软件、算法等学科的远距离虹膜识别研究和开发团队，技术核心团队现有40余人，其中博士4人，硕士23人，来自中科院、清华、北理工、电子科大等知名高校，拥有50多项相关核心发明专利和软件著作权。",
        "虹星核心技术团队潜心10年于远距离虹膜生物特征领域的光机电系统与模式识别算法研究工作，研发出10款以上生物特征成像系统，积累出FPGA、DAVINCI DSP、ARM、TK1、Z7000、IntelSOC等计算平台硬件与嵌入式操作系统研发经验，掌握图像ISP、物体检测、人脸检测、关键点定位、深度估计、三维重建、虹膜识别、活体检测等关键智能图像处理与人工智能技术，构建了从光学传感、机械、嵌入式平台到算法、软件的整套产品研发流程，同时具有成熟的产品供应链体系。"
    ],
    media: [{
        img: "CCTV1.jpg",
        link: "https://tv.cctv.com/2020/07/13/VIDEur3P4Up85RZloU5LNrmV200713.shtml?spm=C31267.P88202112404.ETxIcWSvcwtg.726",
    },
    {
        img: "kjrb.jpg",
        link: "http://digitalpaper.stdaily.com/http_www.kjrb.com/kjrb/html/2018-12/28/node_7.htm",
    },
    {
        img: "kxb.jpeg",
        link: "http://news.sciencenet.cn/dz/dzzz_1.aspx?dzsbqkid=31431",
    },
    {
        img: "mkw.jpg",
        link: "https://www.im2maker.com/news/20180522/4a0325d94e9e7d8b.html",
    },
    {
        img: "txw.jpg",
        link: "https://new.qq.com/omn/20191105/20191105A07PKX00.html",
    },
    {
        img: "tzj.jpg",
        link: "https://baijiahao.baidu.com/s?id=1655690090974623083&wfr=spider&for=pc",
    },
    {
        img: "xhw.jpg",
        link: "http://www.xinhuanet.com/photo/2020-02/28/c_1125641039_3.htm",
    },
    {
        img: "36k.jpg",
        link: "https://36kr.com/search/articles/%E8%99%B9%E6%98%9F%E7%A7%91%E6%8A%80",
    }
    ]
};

export default aboutUsData;